import React from "react";
import classNames from "classnames";
import _ from 'lodash'

import { HelpBlock } from "browser/components/atomic-elements/atoms/help-block/help-block";
import { IBaseProps } from "browser/components/atomic-elements/atoms/base-props";

import { EventChanges } from "../workflow-events/event-changes";
import { renderEventTimestamp } from '../util'
import { InternalViewContext } from "browser/contexts/internal-view/internal-view-context";
import { PlatformTypePretty } from "shared-libs/models/types/storyboard/storyboard-plan";
import apis from "browser/app/models/apis";
import { isUUIDValid } from "shared-libs/helpers/utils";
import { LoadingSpinner, LoadingSpinnerSize } from "browser/components/atomic-elements/atoms/loading-spinner/loading-spinner";
import { Item } from "../../filters/item";

interface ICreationItemProps extends IBaseProps {
  entity: any
  isFirst: boolean
  isLast: boolean
}

export class CreationItem extends React.Component<ICreationItemProps, any> {
  static contextType = InternalViewContext
  declare context: React.ContextType<typeof InternalViewContext>

  store: any
  loadingCount: number

  constructor(props) {
    super(props)

    this.store = apis.getStore()
    this.loadingCount = 0
  }

  public render() {
    const { entity, isFirst, className } = this.props

    // const creationLines = _.map([
    //   "Platform: Mobile",
    //   "Location: Workflow",
    //   "Workflow ID: 1c337a02-dd5c-4bbe-85a2-ede38d3c1564",
    //   "Workflow Task: mobile-task-select-trailer",
    // ], this.renderCreationLine)

    const creationLines = [
      this.renderCreationLine('Platform', PlatformTypePretty[_.get(entity, 'creationSource.platform')]),
    ]

    const { showInternals } = this.context
    if (showInternals) {
      creationLines.push(...[
        this.renderURL(),
        this.renderCreationLine('Component', _.get(entity, 'creationSource.location')),
        this.renderCreationLine('UI Schema', _.get(entity, 'creationSource.uiSchema')),
        this.renderSourceEntity(),
        this.renderCreationLine('Story', _.get(entity, 'creationSource.workflowRoute.story')),
        this.renderCreationLine('Scene', _.get(entity, 'creationSource.workflowRoute.scene')),
        this.renderCreationLine('Task', _.get(entity, 'creationSource.workflowRoute.task')),
      ])
    }

    // todo - convert URL into clickable pretty name, hover for raw value
    // todo - provide link to creation workflow, pretty name + hover for raw value

    if (this.loadingCount > 0) {
      return <LoadingSpinner key='1' size={LoadingSpinnerSize.XS} />
    }

    return (
      <div
        className={classNames('c-timelineEvent', className)}
        key={`${entity.uniqueId}-creation`}
      >
        <div
          className={classNames('c-timelineEvent-line', className, {
            'c-timelineEvent-line--topCutOff': isFirst,
          })}
        />
        <div className='c-timelineEvent-dot' />
        <div className='c-timelineEvent-contentContainer'>
          <div className='c-timelineEvent-body'>
            <HelpBlock>
              <span className='b'>{entity.createdBy?.displayName}</span> created on {renderEventTimestamp(entity.creationDate)}<br />
              <EventChanges>
                { _.filter(creationLines, x => !!x) }
              </EventChanges>
            </HelpBlock>
          </div>
        </div>
      </div>
    )
  }

  private renderSourceEntity() {
    const sourceEntity = this.getSourceEntity()

    if (!sourceEntity) {
      return null
    }

    return this.renderCreationLine('Source Entity', <a href={`/entity/${sourceEntity.uniqueId}`} target='blank'>{_.get(sourceEntity, 'displayName')}</a>)
  }

  private getSourceEntity() {
    const entityId = this.getSourceEntityId()

    return entityId ? this.resolveEntity(entityId) : undefined
  }

  private getSourceEntityId() {
    const workflow = _.get(this.props.entity, 'creationSource.workflowId')

    return workflow || this.findURLSegmentValue(_.get(this.props.entity, 'creationSource.url'), 'entity')
  }

  private renderURL() {
    const url = _.get(this.props.entity, 'creationSource.url')
    if (!url) {
      return null
    }
    const view = this.findURLSegmentValue(url, 'view')

    let viewName = _.get(view, 'view.name')
    if (url.indexOf('search') !== -1) {
      viewName = 'Global Search (Entity Details)'
    } else if (url.indexOf('entity') !== -1) {
      viewName = 'Entity Details (Fullscreen)'
    }

    return this.renderCreationLine('View', <a href={url} target='blank'>{viewName}</a>)
  }

  private findURLSegmentValue(url, segmentName) {
    if (!url) {
      return
    }

    const segments: string[] = url.split('/')
    segments.reverse()

    const firstMatchingSegment = segments.findIndex((segment, index) => {
      return segment === segmentName
    })

    return firstMatchingSegment != undefined
      ? this.resolveEntity(segments[firstMatchingSegment - 1])
      : undefined
  }

  // TODO - refactor (shamelessly stolen from change-set-item.tsx)
  private resolveEntity(entityId) {
    if (!isUUIDValid(entityId)) {
      return
    }

    return this.store.getRecord(entityId) || this.loadEntity(entityId)
  }

  private loadEntity(entityId) {
    this.loadingCount += 1

    this.store.getOrFetchRecord(entityId).then(_ => {
      this.loadingCount -= 1
      this.forceUpdate() // SYNC update, must be called AFTER we update the loading count
    })
  }

  public renderCreationLine = (label, value) => {
    if (!value) {
      return null
    }

    return <span>
      {label}: {value}
      <br />
    </span>
  }
}
